import React from 'react';
import { usePresence } from './motion';

/**
 * The body of a row or card that opens in place: mounted when it opens,
 * animated on the way in and on the way out, and gone once it has left.
 *
 * Replaces `{open && <div className="…">…</div>}`, which unmounts the instant
 * it closes and so cannot animate out. Children are still only rendered while
 * it is mounted, so panels that load their contents on first open keep doing
 * exactly that.
 */
const CollapsePanel = ({
    open,
    className,
    children,
}: {
    open: boolean;
    /** the panel's own class — the motion class is added to it */
    className?: string;
    children: React.ReactNode;
}) => {
    const { mounted, motionProps } = usePresence(open);
    if (!mounted) return null;

    return (
        <div className={`${className ? `${className} ` : ''}nx-collapse`} {...motionProps}>
            {children}
        </div>
    );
};

export default CollapsePanel;
